import './TutorialProgress.css';

interface TutorialProgressProps {
  currentStep: number;
  totalSteps: number;
  progress: number;
  tutorialName: string;
  onExit: () => void;
}

export function TutorialProgress({
  currentStep,
  totalSteps,
  progress,
  tutorialName,
  onExit,
}: TutorialProgressProps) {
  return (
    <div className="tutorial-progress">
      <button className="tutorial-progress-exit" onClick={onExit}>
        ← Exit Tutorial
      </button>
      
      <div className="tutorial-progress-center">
        <span className="tutorial-progress-name">{tutorialName}</span>
        <span className="tutorial-progress-step">
          Step {currentStep} of {totalSteps}
        </span>
      </div>
      
      <div className="tutorial-progress-bar-container">
        <div 
          className="tutorial-progress-bar" 
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
